import { SearchOutlined } from '@ant-design/icons';
import { Input, Space } from 'antd';
import React from 'react';

const { Search } = Input;

interface DishSelectionSearchProps {
    value: string;
    onSearch: (value: string) => void;
    onChange: (value: string) => void;
}

const DishSelectionSearch: React.FC<DishSelectionSearchProps> = ({
    value,
    onSearch,
    onChange,
}) => {
    return (
        <Space direction="vertical" style={{ width: '100%', marginBottom: 10 }} size="middle">
            <Search
                placeholder="Tìm kiếm món ăn..."
                allowClear
                enterButton={<SearchOutlined />}
                size="middle"
                onSearch={onSearch}
                value={value}
                onChange={(e) => onChange(e.target.value)}
            />
        </Space>
    );
};

export default DishSelectionSearch;

